import * as types from "../../actions/types";



const initialState = null


export default function loader (state = initialState, action) {
  switch (action.type) {
      
    case types.SET_SETTINGS_LOADING:
      return action.payload

    default:
      return state;
  }
}